export const projects = [
  {
    id: 1,
    name: 'Donde la chomba',
    description: 'Proyecto que realza la modernidad y menu del restaurante',
    stack: ['HTML', 'CSS3', 'JavaScript'],
    results: [
      'Diseño responsive y mobile-first',
      'Integración de mapa con ubicación real'
    ],
    image: '/projects/Donde-La-Chomba.png',
    demoUrl: 'https://matosdev25.github.io/Donde-La-Chomba/',
    codeUrl: 'https://github.com/matosdev25/Donde-La-Chomba.git'
  },
  {
    id: 2,
    name: 'GRAFIK2®',
    description: 'Sitio web de portfolio minimalista inspirado en iOS26 para profesional creativo',
    stack: ['HTML5', 'CSS3', 'JavaScript', 'GSAP'],
    results: [
      'Animaciones fluidas y atractivas',
      'Optimizado para SEO y performance'
    ],
    image: '/projects/Grafik2.png',
    demoUrl: 'https://matosdev25.github.io/under-construction/',
    codeUrl: '#'
  },
  {
    id: 3,
    name: 'eureka servicios',
    description: 'Landing page de alta conversión para servicio de bricolaje',
    stack: ['Next.js', 'TypeScript', 'Recharts', 'Prisma'],
    results: [
      'Interfaz intuitiva y funcional',
      'Diseño centrado en conversión'
    ],
    image: '/projects/EurekaServicios.png',
    demoUrl: 'https://matosdev25.github.io/under-construction/',
    codeUrl: '#'
  },
  {
    id: 4,
    name: 'Landing Page',
    description: 'Landing page de alta conversión para startup tech',
    stack: ['Next.js', 'Tailwind CSS', 'Framer Motion'],
    results: [
      'Diseño centrado en conversión',
      'Performance 95+ en Lighthouse'
    ],
    image: '/projects/enconstruccion.png',
    demoUrl: 'https://matosdev25.github.io/under-construction/',
    codeUrl: 'https://github.com/matosdev25/under-construction.git'
  }
];

export const services = [
  {
    id: 1,
    title: 'UI/UX Design',
    description: 'Diseño de interfaces modernas, wireframes, prototipos y sistemas de diseño que priorizan la experiencia del usuario.',
    icon: 'Figma'
  },
  {
    id: 2,
    title: 'Diseño Responsive',
    description: 'Desarrollo mobile-first garantizando accesibilidad y experiencia perfecta en todos los dispositivos.',
    icon: 'Smartphone'
  },
  {
    id: 3,
    title: 'Frontend Development',
    description: 'Desarrollo con HTML, CSS y JavaScript con bases sólidas enfocadas en performance y código limpio.',
    icon: 'Code'
  },
  {
    id: 4,
    title: 'Next.js',
    description: 'Aplicaciones web modernas con Next.js, SSR/SSG, optimización SEO y deployments eficientes.',
    icon: 'Zap'
  }
];

export const aboutBullets = [
  { id: 1, text: 'Clean UI', icon: 'Sparkles' },
  { id: 2, text: 'Responsive', icon: 'Monitor' },
  { id: 3, text: 'Performance', icon: 'Gauge' },
  { id: 4, text: 'SEO técnico', icon: 'Search' },
  { id: 5, text: 'Buenas prácticas', icon: 'CheckCircle' }
];

export const counters = [
  { id: 1, number: 15, label: 'Proyectos', suffix: '+', icon: 'Briefcase' },
  { id: 2, number: 10, label: 'Clientes', suffix: '+', icon: 'Users' },
  { id: 3, number: 5, label: 'Años', suffix: '', icon: 'Calendar' },
  { id: 4, number: 10, label: 'Tecnologías', suffix: '+', icon: 'Layers' }
];

export const stackCategories = [
  {
    id: 1,
    category: 'Frontend',
    technologies: ['HTML5', 'CSS3', 'JavaScript', 'Next.js', 'React', 'Tailwind CSS']
  },
  {
    id: 2,
    category: 'UI/UX',
    technologies: ['Figma', 'Design Systems', 'Wireframing', 'Prototyping']
  },
  {
    id: 3,
    category: 'Extras',
    technologies: ['SEO', 'Responsive Design', 'Accesibilidad', 'Performance', 'Git']
  }
];

export const contactInfo = [
  {
    id: 1,
    title: 'WhatsApp',
    value: '+507 6191-2312',
    link: 'https://wa.me/50761912312?text=Hola%20MatosDev%2C%20vi%20tu%20portfolio%20y%20quiero%20cotizar%20un%20proyecto.',
    icon: 'MessageCircle'
  },
  {
    id: 2,
    title: 'Email',
    value: 'matosdev25@gmail.com',
    link: 'mailto:matosdev25@gmail.com',
    icon: 'Mail'
  }
];

export const navLinks = [
  { id: 1, label: 'Inicio', href: '#hero' },
  { id: 2, label: 'Sobre mí', href: '#about' },
  { id: 3, label: 'Servicios', href: '#services' },
  { id: 4, label: 'Proyectos', href: '#projects' },
  { id: 5, label: 'Stack', href: '#stack' },
  { id: 6, label: 'Contacto', href: '#contact' }
];